import * as React from 'react';
export const IcFaceFilter = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 4.24a.6.6 0 00-.48-.4l-1.34-.2-.61-1.29a.59.59 0 00-1.08 0l-.61 1.29-1.34.2a.6.6 0 00-.34 1l1 1-.28 1.46a.61.61 0 00.89.63L19 7.27l1.19.66a.63.63 0 00.64-.04.61.61 0 00.25-.59l-.24-1.43 1-1a.59.59 0 00.16-.63zM10 6a8 8 0 100 16 8 8 0 000-16zm-4 6a1 1 0 112 0 1 1 0 01-2 0zm7.25 5.75a4.85 4.85 0 01-6.5 0 1.001 1.001 0 01.97-1.734.999.999 0 01.34.234 2.88 2.88 0 003.88 0 .998.998 0 011.478.032 1 1 0 01-.168 1.468zM13 13a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
